/** Marker positions (px, centre of marker) on the V1 app screenshots, carried over from the original page. */
export const soundMarkers = {
	A: { x: 114, y: 58 },
	B: { x: 34, y: 298 },
	C: { x: 298, y: 298 },
	D: { x: 82, y: 354 },
	E: { x: 162, y: 394 },
	F: { x: 162, y: 482 },
	G: { x: 162, y: 578 },
};

export const settingsMarkers = {
	A: { x: 138, y: 386 },
	B: { x: 138, y: 538 },
	C: { x: 138, y: 650 },
};

export const v1 = (name: string) => `/images/faq/v1/${name}.svg`;
